<template>
    <layout>
        <TitleLable parentMessage="考试列表"></TitleLable>
        <el-card v-for="(item,index) in list" :key="index" class="list" shadow="hover">
            <div class="exam_title_box">
                <span class="exam_number">{{ index+1 }}</span>
                <span :style="item.status == 0?'color: #409EFF;':(item.status==1?'color: #f56c6c;':'color: #909399;')" size="large" type="text">{{ status[item.status] }}</span>
                <span style="color: #409EFF" class="exam_name">{{ item.plan_name }} {{ item.trem }}阶段考试</span>
                <span class="exam_name">{{ item.title }}</span>
                <span class="exam_score">总分: {{ item.getTotalScore }} 分</span>
            </div>
            <div class="exam_info">发布时间: {{ item.createtime }}</div>
            <div class="exam_info">发布老师: {{ item.teach_name }}</div>
            <div class="exam_info">考试时间: {{ item.start_time_text }} 至 {{ item.end_time_text }}</div>
            <el-divider></el-divider>
            <span style="font-size: 14px;" v-if="item.exam"><i class="el-icon-warning" style="font-size: 16px;color: #f56c6c;"></i> {{ item.tip }}</span>
            <el-button type="primary" @click="startExam(item)" v-if="item.status == 1 || item.status == 0" size="small" class="el-icon-monitor"> 开始考试</el-button>
            <el-button type="primary" @click="startExam(item)" v-if="item.status == 2" size="small" class="el-icon-monitor"> 查看试卷</el-button>

            <!-- 考试结束 -->
            <div v-if="item.status == 2" class="exam_correct">
                <div style="border: none;" class="left">
                    <span style="font-size: 32px;color: #f56c6c;">{{ item.achievement }}</span>
                    <span class="left_title">得分</span>
                </div>
                <!-- <div class="right">
                    <span>{{ item.consuming }}</span>
                    <span class="right_title">用时(min)</span>
                </div> -->
            </div>
            <!-- 考试进行中 -->
            <div v-if="item.status == 1" class="exam_correct">
                <div class="right">
                    <span style="font-size: 18px;">{{ downTime(item.examtime) }}</span>
                    <span class="right_title">倒计时</span>
                </div>
            </div>
        </el-card>
        <el-empty v-if="!list.length" description="暂无考试信息"></el-empty>
        <el-pagination
            v-if="total_number"
            style="margin-top: 20px;"
            @size-change="changeSize"
            @current-change="changeNumber"
            @prev-click="prev"
            @next-click="next"
            :page-size="form.pageSize"
            :total="total_number">
        </el-pagination>
        <div class="paperdialog">
            <el-dialog
            title="我的试卷"
            :visible.sync="dialogVisible"
            width="40%"
            :before-close="handleClose">
            <div v-for="(item, index) in bank_data" :key="index" class="content_paper">
                <div v-for="(test_item, test_index,a_index) in item" :key="a_index">
                    <h4 style="color: #f56c6c;">{{ type_data[index] }} {{ a_index + 1 }}</h4>
                    <div class="declare">
                        <h4>Directions:</h4>
                        <div class="declare_html" v-html="test_item.declare"></div>
                    </div>
                    <div style="color: #000000;line-height: 25px;padding: 12px;" v-html="test_item.body"></div>

                    <div v-show="['1', '2', '3', '9'].includes(index)" v-for="(questionitem, questionindex,q_index) in test_item.test" :key="questionindex" class="readtest" style="padding: 12px;">
                        <div>
                            <h4 style="color: #000000;">{{ q_index + 1 }}. {{ questionitem.question }}</h4>
                            <div 
                                :style="!answeritem || answeritem === '/' ? 'display:none' : ''" 
                                v-for="(answeritem, answerindex) in questionitem.answer" 
                                :key="answerindex" 
                                :class="['question_test', { activ: isAnswerMatch(index, test_index, questionindex, answerindex) }]"
                            >
                                {{ options[answerindex] }}. {{ answeritem }}
                            </div>
                            <div style="font-weight: 700;">
                                <span style="color: #f56c6c;">正确答案：</span>
                                <span style="color: #f56c6c;">{{ questionitem.r_answer }}</span>
                                
                            </div>
                            <div style="display: inline-block;width: 100%;margin-top: 15px;font-weight: 700;">
                                <span style="color: #000000;">我的答案：</span>
                                <span class="answer_item" >{{ subanswer[index] != null?subanswer[index][test_index][questionindex]:'未作答'}}</span>
                            </div>
                        </div>
                    </div>
                    <div v-show="['4', '5'].includes(index)" style="padding: 12px;">
                        <div style="display: inline-block;width: 100%;">
                            <span style="color: #000000;">正确答案：</span>
                            <span class="answer_item" v-for="(answer_item, answer_index) in test_item.answer" :key="answer_index">{{ answer_index + 1 }}. {{ answer_item }}</span>
                        </div>
                        <div style="display: inline-block;width: 100%;margin-top: 15px;">
                            <span style="color: #f56c6c;">我的答案：</span>
                            <span class="answer_item" v-for="(answer_item, answer_index) in getMyAnswers(index, test_index)" :key="answer_index">{{ answer_index + 1 }}. {{ answer_item }}</span>
                        </div>
                    </div>
                    <div v-show="['6', '7'].includes(index)" style="padding: 12px;">
                        <div style="display: inline-block;width: 100%;">
                            <span style="color: #000000;">参考答案：</span>
                            <span>{{ test_item.answer }}</span>
                        </div>
                        <div style="display: inline-block;width: 100%;margin-top: 15px;">
                            <span style="color: #f56c6c;">我的答案：</span>
                            <span>{{ getMySingleAnswer(index, test_index) }}</span>
                        </div>
                    </div>
                </div>
            </div>

            </el-dialog>
        </div>
        
    </layout>
</template>
<script>
import TitleLable from '../../units/Titlelabel.vue';
import Http from "../../apis/student";
export default{
    components:{
        TitleLable
    },
    data(){
        return{
            options: ['A', 'B', 'C', 'D'],
            list:[],
            total_number:0,
            status:['未开始','进行中','已结束'],
            intervalIds: [],
            dialogVisible:false,
            bank_data:[],
            type_data:{1:'单项选择',2:"阅读理解",3:"完型填空",4:"匹配题",5:"单词变形",6:"写作题",7:"翻译题",8:"听力题",9:"判断题"},
            subanswer:[],
            exam_id:0,
            form:{
                page:1,
                pageSize:5
            },
            isRefreshing: false
        }
    },
    activated(){
        this.getList()
    },
    mounted() {
        // 在组件挂载时启动倒计时
        //this.startCountdowns();
    },
    beforeDestroy() {
        // 在组件销毁前清除所有定时器
        this.clearCountdowns();
    },
    methods:{
        isAnswerMatch(index, test_index, questionindex, answerindex) {
            if (
                this.subanswer[index] &&
                this.subanswer[index][test_index] &&
                this.subanswer[index][test_index][questionindex]
            ) {
                return this.subanswer[index][test_index][questionindex] === this.options[answerindex];
            }
            return false;
        },
        getMyAnswers(index, test_index) {
            if (this.subanswer[index] && this.subanswer[index][test_index]) {
                return this.subanswer[index][test_index];
            }
            return [];
        },
        getMySingleAnswer(index, test_index) {
            if (this.subanswer[index] && this.subanswer[index][test_index]) {
                return this.subanswer[index][test_index].answer;
            }
            return '';
        },
        safeAnswerData(index,test_index) {
            if (this.answer_data && this.localQuestionType && index && 
                this.answer_data[this.localQuestionType] && 
                this.answer_data[this.localQuestionType][index] && this.answer_data[this.localQuestionType][index][test_index]) {
                return this.answer_data[this.localQuestionType][index][test_index];
            }
            return false;
        },
        handleClose(){
            this.dialogVisible = false
        },
        startExam(item){

            this.exam_id = item.id
            // this.verifyExam_(item);return false;
            this.$router.push({ name: 'Examination',query:{trem:item.trem,plan_id:item.plan_id,nid:this.exam_id}})
            if(item.status == 0){
                this.$message({
                    type: 'error',
                    message: '考试还未开始'
                });
                return false;
            }
            
            
            if(item.status == 2){

                this.getpreviewExam(item.trem,this.exam_id)

                return false;
            }
            if(item.status == 1){
                
                // 需要验证是否能参加考试
                if(item.achievement){
                    this.$message({
                        type: 'error',
                        message: '系统检测到本次考试已有成绩，不能再次参加考试，请等待考试结束查看成绩、试卷'
                    });
                    return false;
                }
                
                if(item.exam){
                    this.verifyExam_(item)
                }else{
                    this.$router.push({ name: 'Examination',query:{trem:item.trem,plan_id:item.plan_id,nid:this.exam_id}})
                }
            }

        },
        verifyExam_(item){
            const loading = this.$loading({
                lock: true,
                text: '正在验证考试资格...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.2)'
            });
            setTimeout(()=>{
                var params = {}
                params.trem = item.trem
                Http.verifyExam(params).then((res) => {
                    loading.close();
                    this.$message({
                        type: res.code?'success':'error',
                        message: res.msg
                    });
                    if(res.code){
                        this.$router.push({ name: 'Examination',query:{trem:item.trem,plan_id:item.plan_id,nid:this.exam_id}})
                    }
                });
            },500)
            
        },
        getpreviewExam(trem,nid){
            var params = {}
            params.trem = trem
            params.nid = nid
            Http.previewExam(params).then((res) => {
                this.bank_data = res.data.row
                this.subanswer = res.data.subanswer
                this.dialogVisible = true
            });
            
        },
        getList(){
            Http.examlist(this.form).then((res) => {
                this.isRefreshing = false;
                this.clearCountdowns();
                this.list = res.data.data
                this.total_number = res.data.total_number
                this.startCountdowns();
            });
        },
        startCountdowns() {
            this.list.forEach((item, index) => {
                if (item.status === 1 && item.examtime > 0) {
                const intervalId = setInterval(() => {
                    if (item.examtime > 0) {
                    item.examtime--;
                    if (item.examtime === 0 && !this.isRefreshing) {
                        this.isRefreshing = true;
                        this.getList();
                    }
                    } else {
                    clearInterval(intervalId);
                    }
                }, 1000);
                this.intervalIds.push(intervalId);
                }
            });
        },
        clearCountdowns() {
            this.intervalIds.forEach((intervalId) => {
                clearInterval(intervalId);
            });
            this.intervalIds = [];
        },
        downTime(seconds) {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const remainingSeconds = seconds % 60;

            return `${hours.toString().padStart(2, '0')} 时 ${minutes.toString().padStart(2, '0')} 分 ${remainingSeconds.toString().padStart(2, '0')} `;
        },
        // 上一页
        prev(e){

            this.form.page = e
            this.getList()
        },

        // 下一页
        next(e){

            this.form.page = e
            this.getList()
        },

        // 点击页码
        changeNumber(e){

            this.form.page = e
            this.getList()
        },

        // 前往指定页数
        changeSize(e){

            this.form.page = e
            this.getList()
        }
    }
}
</script>
<style lang="less" scoped>
.paperdialog::v-deep .el-dialog__header{
    font-weight: 700 !important;
}
.answer_item{
    display: inline-block;
    padding: 5px 10px;
    color: #409EFF;
    background: #F6F7FB;
    margin-right: 5px;
    border-radius: 5px;
}
.declare{
    margin: 0 auto;
    background: #EAF5FB;
    box-sizing: border-box;
    padding: 15px;
    border-radius: 5px;

    .declare_html{
        font-size: 14px;
        line-height: 28px;
    }
}
.question_test{
    width: 100%;
    display: inline-block;
    line-height: 25px;
    box-sizing: border-box;
    color: #409EFF;
    background: #F6F7FB;
    border-color: #b3d8ff;
    padding: 9px 15px;
    font-size: 14px;
    border-radius: 3px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
}
.activ{
    color: #f56c6c !important;
    background: #fef0f0 !important;
    border-color: #fbc4c4 !important;
    font-weight: 700;
}
.exam_title_box{
    width: 100%;
    display: inline-block;
    margin-bottom: 10px;

    span{
        float: left;
        margin-right: 15px;
    }
    .exam_name{
        padding-right: 15px;
        border-right: 2px #686868 solid;
        font-weight: 700;
    }
    .exam_score{
        opacity: 0.7;
    }
    .exam_number{
        width: 20px;
        height: 20px;

        border-radius: 50px;
        background: #409EFF;
        text-align: center;
        line-height: 20px;
        color: #ffffff;
        font-size: 14px;
    }
}
.exam_info{
    display: inline-block;
    width: 100%;
    height: 30px;
    line-height: 30px;
    opacity: 0.7;
    font-size: 15px;
}
.el-icon-monitor{
    float: right;
    margin-bottom: 15px;
}
.list{
    position: relative;
    margin-bottom: 20px;
}
.exam_correct{
    padding: 15px;
    position: absolute;
    right: 40px;
    top: 40px;
    z-index: 999;


    span{
        width: 100%;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        font-size: 20px;
        font-weight: 700;
    }
    .left{
        width: 120px;
        float: left;
        border-right:1px #C8C9CB solid;
        color: #338ACE;
    }
    .right{
        width: 120px;
        float: left;
        color: #F48687;
    }
    .left_title{
        font-size: 14px !important;
        font-weight: 100 !important;
    }
    .right_title{
        font-size: 14px !important;
        font-weight: 100 !important;
    }
}
@media screen and (max-width: 768px) {
    .el-card {
        margin: 10px 0;

        .exam_title_box {
            display: flex;
            flex-direction: column;

            span {
                float: none;
                margin: 5px 0;
            }

            .exam_name {
                border-right: none;
            }
        }

        .exam_info {
            height: auto;
            line-height: 25px;
        }

        .exam_correct {
            position: static;
            display: flex;
            justify-content: space-around;
            padding: 10px 0;

            .left,
            .right {
                width: auto;
                float: none;
                border-right: none;
            }
        }
    }

    .paperdialog::v-deep .el-dialog {
        
        width: 90% !important;
        
    }
}
</style>